var exports = {
  "kL": "xe533113f--36c5c8--container",
  "Qs": "xe533113f--36c5c8--content",
  "rb": "xe533113f--36c5c8--selectable",
  "vu": "xe533113f--36c5c8--active",
  "Sl": "xe533113f--36c5c8--image",
  "lq": "xe533113f--36c5c8--viewed",
  "hu": "xe533113f--36c5c8--deactivated",
  "q9": "xe533113f--36c5c8--price",
  "h_": "xe533113f--36c5c8--description",
};

module.exports = exports;
